import {useState} from 'react';

export interface UsePaginationResult<T> {
  pageItems: T[];
  page: number;
  setPage: (page: number) => void;
  totalPages: number;
  paginationProps: {page: number; totalPages: number; onChange: (page: number) => void} | undefined;
}

export function usePagination<T>(items: T[], pageSize = 9): UsePaginationResult<T> {
  const [page, setPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const safePage = Math.min(page, totalPages);
  const pageItems = items.slice((safePage - 1) * pageSize, safePage * pageSize);

  return {
    pageItems,
    page: safePage,
    setPage,
    totalPages,
    paginationProps: totalPages > 1 ? {page: safePage, totalPages, onChange: setPage} : undefined,
  };
}
